<section class="ui-kanban-column">
  <header class="ui-kanban-column__header">
    <h3 class="ui-kanban-column__title">
      {{ title() }}
      <span class="ui-kanban-column__count">{{ itemCount() }}</span>
    </h3>
    <div class="ui-kanban-column__actions">
      <ng-content select="[column-actions]" />
    </div>
  </header>
  <div class="ui-kanban-column__body">
    <ng-content />
    @if (itemCount() === 0) {
      <div class="ui-kanban-column__empty">
        <span>{{ emptyMessage() }}</span>
      </div>
    }
  </div>
</section>
